<template>
    <transition-group name="ui-notification" tag="div" class="ui-notification-stack">
        <notification-toast v-for="notification in notifications"
                            :key="notification.id"
                            :notification="notification"
                            @close="remove(notification.id)"></notification-toast>
    </transition-group>
</template>

<script>
    import NotificationToast from './NotificationToast.vue';

    export default {
        name: "NotificationsStack",
        components: {NotificationToast},
        data() {
            return {
                notifications: []
            };
        },
        methods: {
            add(notification) {
                this.notifications.push(notification);
            },
            remove(id) {
                const index = this.notifications.findIndex(n => n.id === id);
                if (index === -1) {
                    return;
                }
                const [notification] = this.notifications.splice(index, 1);
                if (typeof notification.onClose === 'function') {
                    notification.onClose(notification);
                }
            },
            clear() {
                for (const notification of this.notifications.slice()) {
                    this.remove(notification.id);
                }
            }
        }
    };
</script>
